import { getActiveModifierKeys } from '@fabric-app/utils/events/getActiveModifierKeys';
import React__default from 'react';
import { create } from 'zustand';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useModifierKeysStore = create()(delayedTrackZustand((set) => ({
  meta: false,
  shift: false,
  alt: false,
  ctrl: false,
  setModifierKey: (key, value) => set((state) => ({
    ...state,
    [key]: value
  })),
  setModifierKeys: (keys) => set(keys),
  clearAllModifiers: () => set({
    meta: false,
    shift: false,
    alt: false,
    ctrl: false
  })
}), "modifierKeys"));
const useModifierKeysListener = () => {
  React__default.useEffect(() => {
    const keyDownHandler = (e) => {
      useModifierKeysStore.getState().setModifierKeys(getActiveModifierKeys(e));
    };
    const keyUpHandler = (e) => {
      useModifierKeysStore.getState().setModifierKeys(getActiveModifierKeys(e));
    };
    const blurHandler = () => {
      useModifierKeysStore.getState().clearAllModifiers();
    };
    const onMouseDownHandler = (e) => {
      useModifierKeysStore.getState().setModifierKeys(getActiveModifierKeys(e));
    };
    const onMouseUpHandler = (e) => {
      useModifierKeysStore.getState().setModifierKeys(getActiveModifierKeys(e));
    };
    window.addEventListener("keydown", keyDownHandler);
    window.addEventListener("keyup", keyUpHandler);
    window.addEventListener("blur", blurHandler);
    window.addEventListener("mousedown", onMouseDownHandler);
    window.addEventListener("mouseup", onMouseUpHandler);
    return () => {
      window.removeEventListener("keydown", keyDownHandler);
      window.removeEventListener("keyup", keyUpHandler);
      window.removeEventListener("blur", blurHandler);
      window.removeEventListener("mousedown", onMouseDownHandler);
      window.removeEventListener("mouseup", onMouseUpHandler);
    };
  }, []);
};

export { useModifierKeysStore as default, useModifierKeysListener };
//# sourceMappingURL=modifierKeys.js.map
